module.exports = __webpack_public_path__ + "static/media/dota2.d5a7f3df.gif";